import { render, staticRenderFns } from "./FurtherInfoAlert.vue?vue&type=template&id=208d6d34&scoped=true"
import script from "./FurtherInfoAlert.vue?vue&type=script&lang=ts"
export * from "./FurtherInfoAlert.vue?vue&type=script&lang=ts"
import style0 from "./FurtherInfoAlert.vue?vue&type=style&index=0&id=208d6d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d6d34",
  null
  
)

export default component.exports